angular.module( 'angus.directives' ).directive( 'gainsToBudget', [
    'actionViewTemplates',
    function( actionViewTemplates ) {
        return {
            scope: {
                model      : "=actionModel",
                settings   : "=gainsToBudgetWidgetSettings",
                widgetCode : "="
            },
            templateUrl: actionViewTemplates.gainsToBudgetContainer
        };
    }
] );